// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/revoke_vision_invite.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/revoke_vision_invite.proto.
 */
export const file_vision_membership_v1_revoke_vision_invite: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vbWVtYmVyc2hpcC92MS9yZXZva2VfdmlzaW9uX2ludml0ZS5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxIpsBChlSZXZva2VWaXNpb25JbnZpdGVSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5SZXZva2VWaXNpb25JbnZpdGVSZXF1ZXN0LlBhcmFtcxovCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIRCglpbnZpdGVfaWQYAiABKAkidgoaUmV2b2tlVmlzaW9uSW52aXRlUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxLlJldm9rZVZpc2lvbkludml0ZVJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.membership.v1.RevokeVisionInviteRequest
 */
export type RevokeVisionInviteRequest = Message<"protos.vision.membership.v1.RevokeVisionInviteRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.RevokeVisionInviteRequest.Params params = 1;
   */
  params?: RevokeVisionInviteRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.RevokeVisionInviteRequest.
 * Use `create(RevokeVisionInviteRequestSchema)` to create a new message.
 */
export const RevokeVisionInviteRequestSchema: GenMessage<RevokeVisionInviteRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_revoke_vision_invite, 0);

/**
 * @generated from message protos.vision.membership.v1.RevokeVisionInviteRequest.Params
 */
export type RevokeVisionInviteRequest_Params = Message<"protos.vision.membership.v1.RevokeVisionInviteRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string invite_id = 2;
   */
  inviteId: string;
};

/**
 * Describes the message protos.vision.membership.v1.RevokeVisionInviteRequest.Params.
 * Use `create(RevokeVisionInviteRequest_ParamsSchema)` to create a new message.
 */
export const RevokeVisionInviteRequest_ParamsSchema: GenMessage<RevokeVisionInviteRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_revoke_vision_invite, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.RevokeVisionInviteResponse
 */
export type RevokeVisionInviteResponse = Message<"protos.vision.membership.v1.RevokeVisionInviteResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.RevokeVisionInviteResponse.Result result = 1;
   */
  result?: RevokeVisionInviteResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.RevokeVisionInviteResponse.
 * Use `create(RevokeVisionInviteResponseSchema)` to create a new message.
 */
export const RevokeVisionInviteResponseSchema: GenMessage<RevokeVisionInviteResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_revoke_vision_invite, 1);

/**
 * @generated from message protos.vision.membership.v1.RevokeVisionInviteResponse.Result
 */
export type RevokeVisionInviteResponse_Result = Message<"protos.vision.membership.v1.RevokeVisionInviteResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.RevokeVisionInviteResponse.Result.
 * Use `create(RevokeVisionInviteResponse_ResultSchema)` to create a new message.
 */
export const RevokeVisionInviteResponse_ResultSchema: GenMessage<RevokeVisionInviteResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_revoke_vision_invite, 1, 0);

